var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1546 8H3.83333C3.56884 8 3.43487 8.06796 3.36161 8.12124C3.27764 8.1823 3.20178 8.27801 3.13823 8.41665C3.07386 8.5571 3.0367 8.71076 3.01718 8.83853C3.0078 8.8999 3.00343 8.94909 3.00144 8.9794C3.00051 8.99366 3.00014 9.00327 3 9.00748V14C3 14.3419 3.07648 14.5313 3.13974 14.6348C3.20438 14.7406 3.29121 14.8152 3.39552 14.8721C3.50535 14.932 3.62567 14.9667 3.72576 14.9849C3.77366 14.9936 3.8111 14.9975 3.83224 14.9991C3.83815 14.9996 3.84259 14.9998 3.84544 15H12.1667C12.4312 15 12.5651 14.932 12.6384 14.8788C12.7224 14.8177 12.7982 14.722 12.8618 14.5833C12.9261 14.4429 12.9633 14.2892 12.9828 14.1615C12.9922 14.1001 12.9966 14.0509 12.9986 14.0206C12.9995 14.0063 12.9999 13.9967 13 13.9925V9C13 8.6581 12.9235 8.46871 12.8603 8.3652C12.7956 8.25943 12.7088 8.18479 12.6045 8.1279C12.4946 8.06799 12.3743 8.03332 12.2742 8.01512C12.2263 8.00641 12.1889 8.00253 12.1678 8.00088C12.1619 8.00042 12.1574 8.00015 12.1546 8ZM12.1667 7H3.83333C2 7 2 9 2 9V14C2 16 3.83333 16 3.83333 16H12.1667C14 16 14 14 14 14V9C14 7 12.1667 7 12.1667 7Z",
    fill: "#5C5E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8H12V4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4V8ZM11 6.99984V4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4V7L11 6.99984Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLock);
export default __webpack_public_path__ + "static/media/modal-lock.8eb0229d113716d8633f4cad5a8f558d.svg";
export { ForwardRef as ReactComponent };